import 'cropper';

import $ from 'jquery';

import angular from 'angular';

import application from 'application/application';

application

	.service('uploadImagePreviewService', ['$compile', '$http', '$timeout', function($compile, $http, $timeout) {

		return {
			init: function(items, scope, element) {

				var _init = this;

				$('#modalImageCrop').remove();

				$http

					.get('/application/templates/upload-image-preview/upload-image-preview.template.html')

					.then(function(templateResponse) {

						var

							html = '<div class="modal fade" id="modalImageCrop" name="crop-image" tabindex="-1" role="dialog" aria-labelledby="modalImageCropLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">' + templateResponse.data + '</div>',

							// Create new modal
							newScope = items.scope.$new();

						items.modalElement = angular.element(html);

						angular.element('body').append(items.modalElement);

						$compile(items.modalElement)(newScope);

						// All modal functions

						$timeout(function() {

							// Open new modal created

							$('#modalImageCrop').modal('show');

							angular.element('[name="crop-image"]')

								.on('dragover', '.drop-file-area', function(event) {

									event.preventDefault();

									angular.element(this).addClass('dragover');

								})

								.on('dragleave', '.drop-file-area', function(event) {

									event.preventDefault();

									angular.element(this).removeClass('dragover');

								})

								.on('drop', '.drop-file-area', function(event) {

									event.preventDefault();

									angular.element(this).removeClass('dragover');

									_init.generateModal(event, this, items);

								})

								.on('closed.modalImageCrop', function(e) {

									angular.element(e.currentTarget).remove();

								})

								.on('click', '.crop-image-button', function() {

									$timeout(function() {

										_init.crop(this, items, function() {

											$timeout(function() {

												angular.element(document).triggerHandler('upload-image-preview-callback');

												element.scope().$eval(element.attr('upload-image-preview-callback'));

											});

										});

									}, 25);

									$('#modalImageCrop').modal('hide');

								})

								.on('click', '.drop-file-area', function() {

									angular.element('.modal-crop-image-input').trigger('click');

								})

								.on('click', '.modal-crop-image-input', function(event) {

									event.stopPropagation();

								})

								.on('change', '.modal-crop-image-input', function(event) {

									_init.generateModal(event, this, items);

								})
								.on('hidden.bs.modal', function() {
									$('body').removeClass('modal-open');
								});

						});

					});

			},
			generateModal: function(event, imageTemp, items) {

				// Continuar refatorando e substituir o modalElement por outra coisa

				var

					self = this,

					loaderHtml = angular.element('<div class="modal-crop-image-loader"><div class="loader" ng-activity-indicator="DottedGrey" skip-ng-show="yes" class="ng-scope">Carregando...</div></div>'),

					img = new Image(),

					modalDescriptionElement = items.modalElement.find('.modal-crop-image-description');

				modalDescriptionElement.append(loaderHtml).css('position', 'relative');

				$compile(loaderHtml)(items);

				modalDescriptionElement.find('.modal-crop-image-loader').fadeIn(300);

				var file = '';

				if (event.originalEvent.dataTransfer)

					file = event.originalEvent.dataTransfer.files[0];

				else if ($(imageTemp).is('[type="file"]') && imageTemp.files)

					file = imageTemp.files[0];

				if (!file.type.match('image.*')) {

					self.stopCropProcess(imageTemp, items);

					return alert('O arquivo que você selecionou não é uma imagem.');

				}

				img.src = URL.createObjectURL(file);

				img.setAttribute('ng-src', URL.createObjectURL(file));

				img.setAttribute('class', 'crop-image-img');

				img.onload = function() {

					if (this.width < items.thumbWidth || this.height < items.thumbHeight) {

						self.stopCropProcess(imageTemp, items);

						return alert('A imagem deve ter no minimo ' + items.thumbWidth + 'px de largura por ' + items.thumbHeight + 'px de altura.');

					}

					modalDescriptionElement.append(img);

					modalDescriptionElement.css('height', modalDescriptionElement.find('.crop-image-img').height());

					modalDescriptionElement.css('width', modalDescriptionElement.find('.crop-image-img').width());

					modalDescriptionElement.find('img').cropper({
						aspectRatio: parseInt(items.thumbWidth) / parseInt(items.thumbHeight),
						scalable: false,
						zoomable: false,
						movable: false,
						toggleDragModeOnDblclick: false
					});

					modalDescriptionElement.find('.drop-file-area').hide();

					modalDescriptionElement.find('.modal-crop-image-loader').fadeOut(0, function() {

						loaderHtml.remove();

						angular.element('.cropper-container').fadeIn(300);

						angular.element('.crop-image-button').removeAttr('disabled');

					});

				};

			},
			stopCropProcess: function(self, items) {

				items.modalElement.find('.modal-crop-image-loader').hide();

			},
			crop: function(imageTemp, items, callback) {

				var

					cropedResultBase64 = items.modalElement.find('.crop-image-img').cropper('getCroppedCanvas').toDataURL('image/png'),

					thumb = new Image,

					canvas = document.createElement('canvas'),

					ctx = canvas.getContext('2d');

				thumb.src = cropedResultBase64;

				thumb.setAttribute('ng-src', cropedResultBase64);

				thumb.onload = function() {

					canvas.width = items.thumbWidth;

					canvas.height = items.thumbHeight;

					ctx.drawImage(this, 0, 0, items.thumbWidth, items.thumbHeight);

					items.scope.ngModel = {
						url: canvas.toDataURL('image/png'),
						format: '.png'
					};

					$timeout(function() {

						if (typeof callback === 'function')

							callback();

					});

				};

			}
		};

	}]);
